module.exports = __webpack_public_path__ + "static/img/开发区规划馆.c79faf21.png";